import styled from 'styled-components';
import fonts from '../../../../../helpers/fonts';
import spacing from '../../../../../helpers/spacing';

/* This wrapper is needed as the legend tag always takes up the full width in Chrome without it */
export const LabelWrapper = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

export const StyledLabel = styled.label`
  ${fonts.paragraph};
  & {
    font-weight: normal;
  }

  display: inline-block;
  white-space: break-spaces;

  &::after {
    margin-right: ${spacing(1)};
    content: '';
  }
`;
